/** Realistic staff roster for marketing screenshots (no login accounts). */
export const SAMPLE_DEMO_EMPLOYEES = [
  { firstName: 'Alex', lastName: 'Morgan', title: 'Senior Stylist', role: 'manager' },
  { firstName: 'Jordan', lastName: 'Lee', title: 'Lead Technician', role: 'employee' },
  { firstName: 'Taylor', lastName: 'Brooks', title: 'Service Specialist', role: 'employee' },
  { firstName: 'Casey', lastName: 'Rivera', title: 'Front Desk', role: 'employee' },
  { firstName: 'Morgan', lastName: 'Chen', title: 'Senior Associate', role: 'employee' },
  { firstName: 'Riley', lastName: 'Patel', title: 'Team Lead', role: 'manager' },
  { firstName: 'Jamie', lastName: 'Foster', title: 'Consultant', role: 'employee' },
  { firstName: 'Sam', lastName: 'Nguyen', title: 'Junior Specialist', role: 'employee' },
  { firstName: 'Drew', lastName: 'Collins', title: 'Operations Manager', role: 'manager' },
  { firstName: 'Avery', lastName: 'Kim', title: 'Client Coordinator', role: 'employee' },
  { firstName: 'Quinn', lastName: 'Adams', title: 'Senior Consultant', role: 'employee' },
  { firstName: 'Blake', lastName: 'Turner', title: 'Associate', role: 'employee' },
  { firstName: 'Cameron', lastName: 'Hayes', title: 'Wellness Coach', role: 'employee' },
  { firstName: 'Dakota', lastName: 'Reed', title: 'Practice Manager', role: 'manager' },
  { firstName: 'Emery', lastName: 'Walsh', title: 'Therapist', role: 'employee' },
  { firstName: 'Finley', lastName: 'Grant', title: 'Esthetician', role: 'employee' },
  { firstName: 'Harper', lastName: 'Diaz', title: 'Receptionist', role: 'employee' },
  { firstName: 'Jesse', lastName: 'Morris', title: 'Trainer', role: 'employee' },
  { firstName: 'Kai', lastName: 'Bennett', title: 'Shift Supervisor', role: 'manager' },
  { firstName: 'Logan', lastName: 'Price', title: 'Technician', role: 'employee' },
  { firstName: 'Noah', lastName: 'Santos', title: 'Care Specialist', role: 'employee' },
  { firstName: 'Parker', lastName: 'Ellis', title: 'Coordinator', role: 'employee' },
  { firstName: 'Reese', lastName: 'Hughes', title: 'Senior Therapist', role: 'employee' },
  { firstName: 'Sage', lastName: 'Coleman', title: 'Assistant Manager', role: 'manager' },
];
